import * as React from "react";

export const NewTaskDialog = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M24 20h13v2H24v-2Zm-5-.5h3v3h-3v-3Zm0 7h3v3h-3v-3Zm0 7h3v3h-3v-3Zm5-6.5h13v2H24v-2Zm0 7h13v2H24v-2Z"
      fill="#333"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
